<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-space-between">
              <div>
                <div class="d-flex align-center">
                  <v-icon color="kbDarkBlue" class="mr-3">mdi-calendar-check</v-icon>
                  <h3 class="kbDarkBlue--text text-capitalize"
                      style="font-size: 26px">
                    {{ selectedJourney.name }}
                  </h3>
                </div>
                <div class="text-right">
                  <v-chip class="mt-1"
                          :color="selectedJourney.inactive ? 'kbRed' : 'kbGreen'"
                          dark
                          label
                          x-small>
                    {{ selectedJourney.inactive ? $t('general.inactive') : $t('general.active') }}
                  </v-chip>
                </div>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="kbDarkBlue"
                         icon
                         large
                         v-on="on"
                         @click="$router.back()">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.goBack') }}</span>
              </v-tooltip>
            </v-col>

            <v-col cols="12" class="pt-0">
              <v-divider/>
            </v-col>

            <v-col cols="12"
                   sm="6"
                   class="pl-0 align-self-stretch"
                   v-if="selectedJourney.dependencieOf &&
                                   Array.isArray(selectedJourney.dependencieOf) &&
                                   selectedJourney.dependencieOf.length > 0">
              <span class="kbDarkBlue--text d-block pl-3"
                    style="font-size: 18px">Depende de</span>
              <v-chip class="ma-2 custom-chip-journey-id"
                      color="kbLight"
                      text-color="kbDarkBlue"
                      v-for="dependencie in selectedJourney.dependencieOf"
                      :key="dependencie.id">
                <!--@click:close="close"-->
                <v-avatar left>
                  <v-icon :color="dependencie.mainColor">mdi-circle</v-icon>
                </v-avatar>
                <div class="container-id">
                  <div>
                    {{ dependencie.name }}
                  </div>
                  <div>
                    {{ 'ID: ' + dependencie.id }}
                  </div>
                </div>
              </v-chip>
            </v-col>

            <v-col cols="12"
                   sm="6"
                   class="pl-0 align-self-stretch"
                   v-if="selectedJourney.dependsOn &&
                                   Array.isArray(selectedJourney.dependsOn) &&
                                   selectedJourney.dependsOn.length > 0">
              <span class="kbDarkBlue--text d-block pl-3"
                    style="font-size: 18px">Es dependencia de</span>
              <v-chip class="ma-2 custom-chip-journey-id"
                      color="kbLight"
                      text-color="kbDarkBlue"
                      v-for="dependencie in selectedJourney.dependsOn"
                      :key="dependencie.id">
                <!--@click:close="close"-->
                <v-avatar left>
                  <v-icon :color="dependencie.mainColor">mdi-circle</v-icon>
                </v-avatar>
                <div class="container-id">
                  <div>
                    {{ dependencie.name }}
                  </div>
                  <div>
                    {{ 'ID: ' + dependencie.id }}
                  </div>
                </div>
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <JourneyExtraDataManagement/>
    </v-col>
  </v-row>
</template>

<script>
import JourneyExtraDataManagement from '@/pages/App/Journey/JourneyExtraDataManagement'
import { mapGetters, mapState } from 'vuex'
export default {
  components: { JourneyExtraDataManagement },
  computed: {
    ...mapGetters(['companyUuid', 'appUuid']),
    ...mapState({
      selectedJourney: state => state.journey.selectedJourney
    })
  },
  async created () {
    await this.getJourney()
  },
  data () {
    return {
      loadingJourney: true
    }
  },
  methods: {
    async getJourney () {
      this.loadingJourney = true
      try {
        await this.$store.dispatch('getJourney', {
          companyId: this.companyUuid,
          appId: this.appUuid,
          journeyId: this.$route.params.journeyId
        })
        console.log(this.selectedJourney)
        this.loadingJourney = false
      } catch (e) {
        this.loadingJourney = false
        throw e
      }
    }
  }
}
</script>

<style>
    .container-id {
        display: flex;
        flex-direction: column;
    }
    .custom-chip-journey-id.v-size--default {
        height: 38px;
    }
</style>
